import React, { useState, useEffect } from 'react';

const ThemeToggleButton = () => {
  const [darkTheme, setDarkTheme] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('darkTableTheme');
    if (savedTheme === 'true') {
      setDarkTheme(true);
      applyDarkTheme(true);
    }
  }, []);

  const applyDarkTheme = (isDark) => {
    const tableWrappers = document.querySelectorAll('.table-wrapper');
    tableWrappers.forEach(wrapper => {
      if (isDark) {
        wrapper.classList.add('dark-theme');
      } else {
        wrapper.classList.remove('dark-theme');
      }
    });
  };

  const toggleTheme = () => {
    setDarkTheme((prevTheme) => {
      const newTheme = !prevTheme;
      applyDarkTheme(newTheme);
      localStorage.setItem('darkTableTheme', newTheme.toString());
      return newTheme;
    });
  };

  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={darkTheme}
        onChange={toggleTheme}
      />
      <span className="slider round"></span>
    </label>
  );
};

export default ThemeToggleButton;
